export default __webpack_public_path__ + "static/media/_DSC0885.f494c354.JPG";